import { jsx as m } from "react/jsx-runtime";
import { UnstyledLink as f } from "../UnstyledLink/UnstyledLink.js";
import { linkVariants as l } from "./Link.variants.js";
const x = ({
  children: o,
  className: r,
  disableUnderline: s = !1,
  disableVisitedStyles: t = !1,
  isMonochrome: n = !1,
  url: a = "#",
  ...e
}) => {
  const { root: i } = l;
  return /* @__PURE__ */ m(
    f,
    {
      className: i({
        className: r,
        disableUnderline: s,
        disableVisitedStyles: t,
        isMonochrome: n
      }),
      url: a,
      ...e,
      children: o
    }
  );
};
export {
  x as Link
};
